import { Component, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { CreatedPoliciesComponent } from '../../../org-admin/access-requests/created-policies/created-policies.component';

export type GrantedAccessSubTab = 'approved' | 'issued';
export type GrantedAccessPortal = 'consumer' | 'provider' | 'org-admin';

@Component({
  selector: 'app-granted-access-panel',
  standalone: true,
  imports: [CommonModule, CreatedPoliciesComponent],
  templateUrl: './granted-access-panel.component.html',
  styleUrl: './granted-access-panel.component.scss',
})
export class GrantedAccessPanelComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  /**
   * Host portal (consumer / provider / org-admin).
   * Granted Access always loads via /policy/consumer with policyType filters;
   * policyListType=owned keeps that routing regardless of portal.
   */
  @Input() policyPortal: GrantedAccessPortal = 'consumer';

  activeSubTab: GrantedAccessSubTab = 'approved';

  readonly subTabs: Array<{ label: string; value: GrantedAccessSubTab }> = [
    { label: 'Approved Request', value: 'approved' },
    { label: 'Issued policies', value: 'issued' },
  ];

  readonly approvedPolicyTypes = ['ACCESS_REQUEST_APPROVED'];
  readonly issuedPolicyTypes = ['INDIVIDUAL', 'GROUP'];

  get activePolicyTypes(): string[] {
    return this.activeSubTab === 'issued' ? this.issuedPolicyTypes : this.approvedPolicyTypes;
  }

  get conversationRoute(): string | null {
    return this.activeSubTab === 'approved' ? `/${this.policyPortal}/requests` : null;
  }

  ngOnInit(): void {
    const subTabFromUrl = this.route.snapshot.queryParamMap.get('grantedSubTab');
    if (subTabFromUrl === 'approved' || subTabFromUrl === 'issued') {
      this.activeSubTab = subTabFromUrl;
    }
  }

  setActiveSubTab(tab: GrantedAccessSubTab): void {
    if (this.activeSubTab === tab) {
      return;
    }
    this.activeSubTab = tab;
    void this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { grantedSubTab: tab },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }
}
